import React, { useState, useRef, useEffect } from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import { auth, db } from '../firebaseConfig';
import { FaCamera } from 'react-icons/fa';

const ProfilePicture = ({ 
  imageUrl, 
  size = 'md', 
  className = '', 
  onUpdate = null,
  alt = 'Profile Picture',
  isProfilePage = false
}) => {
  const [isUploading, setIsUploading] = useState(false);
  const [currentImage, setCurrentImage] = useState(imageUrl);
  const [error, setError] = useState('');
  const fileInputRef = useRef();

  useEffect(() => {
    setCurrentImage(imageUrl);
  }, [imageUrl]);

  // Define more granular size classes
  const sizeClasses = {
    xs: 'h-8 w-8',
    sm: 'h-10 w-10',
    md: 'h-12 w-12',
    lg: 'h-16 w-16',
    xl: 'h-24 w-24',
    '2xl': 'h-32 w-32'
  };

  // Fallback image
  const fallbackImage = '/logo.png';

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validate file type
    if (!file.type.startsWith('image/')) {
      setError('Please upload an image file');
      return;
    }

    // Validate file size (4MB)
    if (file.size > 4 * 1024 * 1024) {
      setError('File size must be less than 4MB');
      return;
    }

    setIsUploading(true);
    setError('');

    try {
      // Get the user's Google access token
      const accessToken = await auth.currentUser.getIdToken();

      // Upload to Google Drive
      // const downloadURL = await uploadToGoogleDrive(file, accessToken);

      // Update user profile in Firestore
      // const userRef = doc(db, 'profiles', auth.currentUser.uid);
      // await updateDoc(userRef, {
      //     photoURL: downloadURL
      // });

      // Update auth profile
      // if (auth.currentUser) {
      //     await auth.currentUser.updateProfile({
      //         photoURL: downloadURL
      //     });
      // }

      // setCurrentImage(downloadURL);
      // if (onUpdate) {
      //     onUpdate(downloadURL);
      // }
    } catch (err) {
      console.error('Error uploading profile picture:', err);
      setError('Failed to upload profile picture. Please try again.');
    } finally {
      setIsUploading(false);
    }
  };

  const handleClick = () => {
    if (!auth.currentUser) {
      setError('Please sign in to update your profile picture');
      return;
    }
    fileInputRef.current.click();
  };

  return (
    <div 
      className={`
        ${sizeClasses[size]} 
        rounded-full 
        overflow-hidden 
        border-2 
        border-purple-500 
        ${className}
        ${onUpdate ? 'cursor-pointer hover:opacity-80 transition-opacity' : ''}
      `}
      onClick={onUpdate}
    >
      <img 
        src={currentImage || fallbackImage} 
        alt={alt} 
        className="w-full h-full object-cover"
        onError={(e) => { e.target.src = fallbackImage }}
      />
      {isProfilePage && (
        <>
          <input
            type="file"
            ref={fileInputRef}
            onChange={handleFileChange}
            accept="image/*"
            className="hidden"
          />
          <button
            onClick={handleClick}
            disabled={isUploading}
            className="absolute bottom-0 right-0 w-8 h-8 bg-purple-500 rounded-full flex items-center justify-center text-white opacity-0 group-hover:opacity-100 transition-opacity hover:bg-purple-600"
            title={isUploading ? 'Uploading...' : 'Update profile picture'}
          >
            {isUploading ? (
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
            ) : (
              <FaCamera size={14} />
            )}
          </button>
        </>
      )}
      {error && (
        <div className="absolute top-full left-0 mt-2 text-sm text-red-500 bg-red-100 dark:bg-red-900/50 px-2 py-1 rounded z-10">
          {error}
        </div>
      )}
    </div>
  );
};

export default ProfilePicture;